// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__3uR09","active":"Switch_active__9xQWF","disabled":"Switch_disabled__r8c_D"};